function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M24,11.46a.37.37,0,0,0,0-.14.14.14,0,0,0,0-.07,0,0,0,0,1,0,0l-.11-.11,0,0L20,8.49V.5a.5.5,0,0,0-.5-.5H4.5A.5.5,0,0,0,4,.5v8L.23,11.08h0l-.12.12a0,0,0,0,1,0,0,.14.14,0,0,0,0,.07.37.37,0,0,0,0,.14s0,0,0,0V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V11.5S24,11.48,24,11.46Zm-1.38,0L20,13.23V9.7ZM4,13.23,1.39,11.49,4,9.7ZM22,23H2a1,1,0,0,1-1-1V12.43l5.22,3.49A.57.57,0,0,0,6.5,16a.52.52,0,0,0,.42-.22.51.51,0,0,0-.14-.7L5,13.9V1H19V13.9l-1.78,1.18a.51.51,0,0,0-.14.7.52.52,0,0,0,.42.22.57.57,0,0,0,.28-.08L23,12.43V22A1,1,0,0,1,22,23Zm-1.19-2.89a.5.5,0,0,1,.08.7.48.48,0,0,1-.39.19.51.51,0,0,1-.31-.11L15.32,17H8.68L3.81,20.89a.5.5,0,0,1-.62-.78l5-4A.51.51,0,0,1,8.5,16h7a.51.51,0,0,1,.31.11ZM7,3.5A.5.5,0,0,1,7.5,3h2a.5.5,0,0,1,0,1h-2A.5.5,0,0,1,7,3.5ZM9.5,6h7a.5.5,0,0,1,0,1h-7a.5.5,0,0,1,0-1ZM7,9.5A.5.5,0,0,1,7.5,9h9a.5.5,0,0,1,0,1h-9A.5.5,0,0,1,7,9.5Zm0,3a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,0,1h-9A.5.5,0,0,1,7,12.5Z"
})));

var SvgEnvelopeOpen = function SvgEnvelopeOpen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEnvelopeOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelope-open.2da9ad72.svg";
export { ForwardRef as ReactComponent };